// import Skeleton from '@mui/material/Skeleton';
// import TableMui from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import TablePagination from '@mui/material/TablePagination';
// import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-regular-svg-icons'
import { Tooltip } from '@mui/material';

// import BtnPad from '../BtnPad'
// import Button from '../Button'
import { DisplayUser } from '../Display'

const gfxCellAlignment = {
	datetime: 'center',
	date: 'center',
	money: 'right',
	number: 'right',
	integer: 'right',
	bool: 'center',
	boolean: 'center',
	icon: 'center',
}
export const evalAlignment = def => def?.cellAlign || (def?.type && gfxCellAlignment.hasOwnProperty(def.type) ? gfxCellAlignment[def.type] : 'left')

const tsInterval = (milliseconds) => {
	let seconds = milliseconds > 1 ? Math.round(milliseconds/1000) : 0

	const years = seconds >= 31536000 ? Math.floor(seconds / 31536000) : 0
	seconds %= 31536000

	const months = seconds >= 2592000 ? Math.floor(seconds / 2592000) : 0
	seconds %= 2592000

	const days = seconds >= 86400 ? Math.floor(seconds / 86400) : 0
	seconds %= 86400

	const hours = seconds >= 3600 ? Math.floor(seconds / 3600) : 0
	seconds %= 3600

	const minutes = seconds >= 60 ? Math.floor(seconds / 60) : 0
	seconds %= 60

	const timerStrings = []
	years && timerStrings.push(years + 'anni')
	months && timerStrings.push(months + 'mesi')
	days && timerStrings.push(days + 'gg')
	hours && timerStrings.push(hours + 'h')
	minutes && timerStrings.push(minutes + 'm')
	seconds && timerStrings.push(seconds + 's')
	return timerStrings.length ? timerStrings.join(' ') : '0s'
}

export const calcValue = async (def, row) => {
	let value = def?.field ? row?.[def.field] : (typeof(def?.content)==='function' ? await def.content(row) : def.content)
	const tooltip = (typeof(def?.tooltip)==='function' ? def.tooltip(row) : def.tooltip)
	const iconColor = def?.iconColor || undefined

	switch(def?.type) {
		case 'datetime':
			if(value) {
				let dateObj = new Date(value)
				value = ("0" + dateObj.getDate()).slice(-2)
				value += '/' + ("0" + (dateObj.getMonth() + 1)).slice(-2)
				value += '/' + dateObj.getFullYear()
				value += ' ' + ("0" + dateObj.getHours()).slice(-2)
				value += ':' + ("0" + dateObj.getMinutes()).slice(-2)
				value += ':' + ("0" + dateObj.getSeconds()).slice(-2)
			}
		break
		case 'datetime-interval':
			value = tsInterval(value)
		break
		case 'date':
			if(value) {
				let dateObj = new Date(value)
				value = ("0" + dateObj.getDate()).slice(-2)
				value += '/' + ("0" + (dateObj.getMonth() + 1)).slice(-2)
				value += '/' + dateObj.getFullYear()
			}
		break
		case 'money':
			if(value) {
				value = (value/10000)
					.toFixed(2)
					.split('.')
				let valueInt = value[0]
					.split('')
					.reduceRight((acc, cur, idx, arr) =>
						cur + ((arr.length-idx)%3===1 ? '.' : '') + acc)
				value = '€ ' + valueInt + ',' + value[1]
			}
			else
				value = '-'
		break
		case 'number':
			value = value ? (value/10000).toFixed(2).replace(/\./g, ",") : '-'
		break
		case 'integer':
			value = value ? (value/10000).toString().replace(/\./g, ",") : '-'
		break
		case 'bool':
		case 'boolean':
			const trueIcon = def.hasOwnProperty('trueIcon') ? def.trueIcon : faCheck
			const falseIcon = def.hasOwnProperty('falseIcon') ? def.falseIcon : faTimes
			const valueIcon = value ? trueIcon : falseIcon
			value = valueIcon ? <FontAwesomeIcon icon={valueIcon} size="lg" color={iconColor} /> : ''
		break;
		case 'multiline':
			value = value ? value.split('\n').map((row, rowIdx) =>
				(<Box key={rowIdx}>{row}</Box>)
			) : ' '
		break
		case 'icon':
			value = Boolean(value) && <FontAwesomeIcon icon={value} size="lg" color={iconColor} />
		break;
		case 'user':
			value = <DisplayUser uid={value} />
		break
		case 'color':
			value = (
				<Box sx={{
					bgcolor: value,
					border: '1px solid black',
					width: 100,
					textAlign: 'center',
				}}>
					{value || '-'}
				</Box>
			)
		break;
	}
	return (tooltip && value) ? <Tooltip title={tooltip}>{value}</Tooltip> : (value || ' ')
}
